/* eslint-disable */
import { observable, action } from 'mobx'
import axios from 'axios'

import Auth from './Auth'
import User from './User'

import config from '../config'

import tValidation from '../errors/community/validation.json'

class Community {
  @observable all = []
  @observable search = []
  @observable my = []

  @observable users = {}
  @observable groups = {}

  @observable
  response = {
    create: null
  }

  @action
  getCommunity = comId => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/community/${comId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        if (!res.data.data) {
          return Promise.reject()
        }

        {
          const index = this.all.slice().findIndex(c => c.id === comId)
          this.all.replace([
            ...(index > -1
              ? [
                  ...this.all.slice(0, index),
                  res.data.data,
                  ...this.all.slice(index + 1)
                ]
              : [...this.all.slice(), res.data.data])
          ])
        }

        const commUsers = res.data.data.groups.reduce(
          (arr, g) => [
            ...arr,
            ...g.users.reduce(
              (_arr, u) => [
                ..._arr,
                ...(arr.find(_u => _u.id === u.id) ? [] : [u])
              ],
              []
            )
          ],
          []
        )

        if (commUsers.find(u => u.id === Auth.token.userId)) {
          const index = this.my.slice().findIndex(c => c.id === comId)
          this.my.replace([
            ...(index > -1
              ? [
                  ...this.my.slice(0, index),
                  res.data.data,
                  ...this.my.slice(index + 1)
                ]
              : [...this.my.slice(), res.data.data])
          ])
        }

        this.users = {
          ...this.users,
          [comId]: commUsers
        }

        this.groups = {
          ...this.groups,
          [comId]: res.data.data.groups.reduce((arr, g) => {
            const { users, ...group } = g
            return [...arr, { ...group, users: users.map(u => u.id) }]
          }, [])
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
        return Promise.reject(e)
      })
  }

  @action
  getMyCommunities = () => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/community/*/user/${Auth.token.userId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        if (!res.data.data.groups) {
          return Promise.resolve()
        }

        return Promise.all(
          res.data.data.groups
            .reduce(
              (arr, g) => [...arr, ...(arr.includes(g.comId) ? [] : [g.comId])],
              []
            )
            .map(g => this.getCommunity(g))
        )
      })
      .catch(e => {
        console.warn(e)
      })
  }
  @action
  getUserCommunities = userId => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/community/*/user/${userId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        if (!res.data.data.groups) {
          return Promise.resolve()
        }

        return Promise.all(
          res.data.data.groups
            .reduce(
              (arr, g) => [...arr, ...(arr.includes(g.comId) ? [] : [g.comId])],
              []
            )
            .map(g => this.getCommunity(g))
        )
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  searchCommunity = value => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/search/?type=community&q=name:${value}*`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res =>
        Promise.all(
          res.data.hits.hits
            .reduce((arr, u) => [...arr, u._source.id], [])
            .map(g => this.getCommunity(g))
        ).then(communities => {
          this.search.replace(communities)
          return communities
        })
      )
      .catch(e => {
        console.warn(e)
      })
  }

  // admin only
  @action
  getAllCommunities = value => {
    return axios({
      method: 'get',
      url: `${
        config.api_uri
      }/search/?type=community&q=(*)&page=1&limit=1999&sortBy=name&sortType=asc`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        Promise.all(
          res.data.hits.hits.reduce((arr, u) => [...arr, u._source], [])
        ).then(communities => {
          this.search.replace(communities)
          this.all.replace(communities)
          return communities
        })
      })
      .catch(e => {
        console.warn(e)
      })
  }

  @action
  postCommunity = data => {
    const values = Object.keys(data).reduce((arr, key) => {
      return [
        ...arr,
        ...(typeof data[key] === 'string'
          ? [data[key]]
          : Object.keys(data[key]).map(_key => data[key][_key]))
      ]
    }, [])

    if (!values.every(item => item.length > 0)) {
      this.response = {
        ...this.response,
        create: {
          statusCode: 400,
          data: {
            message: 'All fields are required'
          }
        }
      }

      return Promise.reject()
    }

    return axios({
      method: 'post',
      url: `${config.api_uri}/community/`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data
    })
      .then(res => {
        this.response = {
          ...this.response,
          create: {
            statusCode: res.status,
            data: res.data
          }
        }
      })
      .catch(e => {
        console.warn(e)
        this.response = {
          ...this.response,
          create: {
            statusCode: e.response.status,
            data: {
              ...e.response.data,
              ...{
                ...(+e.response.status === 500
                  ? { message: 'Internal server error. Try again later.' }
                  : {
                      message: Object.keys(tValidation.fields).reduce(
                        (acc, key) => acc.replace(key, tValidation.fields[key]),
                        e.response.data.message
                      )
                    })
              }
            }
          }
        }

        return Promise.reject()
      })
  }

  @action
  patchCommunity = (comId, field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/community/${comId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: 'replace',
        path: `/${field}`,
        value
      }
    })
      .then(res => {
        {
          const index = this.all.slice().findIndex(c => c.id === comId)
          this.all.replace([
            ...(index > -1
              ? [
                  ...this.all.slice(0, index),
                  {
                    ...this.all.slice()[index],
                    [field]: value
                  },
                  ...this.all.slice(index + 1)
                ]
              : [...this.all.slice()])
          ])
        }

        {
          const index = this.my.slice().findIndex(c => c.id === comId)
          if (index > -1) {
            this.my.replace([
              ...(index > -1
                ? [
                    ...this.my.slice(0, index),
                    {
                      ...this.my.slice()[index],
                      [field]: value
                    },
                    ...this.my.slice(index + 1)
                  ]
                : [...this.my.slice()])
            ])
          }
        }
      })
      .catch(e => {
        console.warn(e)
        return Promise.reject()
      })
  }

  @action
  patchCommunityGroup = (comId, groupId, field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/community/${comId}/group/${groupId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: 'replace',
        path: `/${field}`,
        value
      }
    })
      .then(res => {
        const index = this.groups[comId].findIndex(g => g.id === groupId)
        if (index > -1) {
          this.groups = {
            ...this.groups,
            [comId]: [
              ...this.groups[comId].slice(0, index),
              {
                ...this.groups[comId].slice()[index],
                [field]: value
              },
              ...this.groups[comId].slice(index + 1)
            ]
          }
        }
      })
      .catch(e => {
        console.warn(e)
        return Promise.reject()
      })
  }

  @action
  postCommunityGroup = (comId, data) => {
    return axios({
      method: 'post',
      url: `${config.api_uri}/community/${comId}/group/`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        community: comId,
        name: data.name,
        permissions: data.permissions || {}
      }
    })
      .then(res => {
        this.groups = {
          ...this.groups,
          [comId]: [
            ...this.groups[comId].slice(),
            { ...res.data.data, users: [] }
          ]
        }

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
        return Promise.reject()
      })
  }

  @action
  patchCommunityUserGroup = (comId, userId, field, value) => {
    return axios({
      method: 'patch',
      url: `${config.api_uri}/community/${comId}/user/${userId}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: {
        op: 'replace',
        path: `/${field}`,
        value
      }
    })
      .then(res => {
        Object.keys(value).forEach(key => {
          const groupIndex = this.groups[comId].findIndex(_g => _g.id === key)
          const userIndex = this.groups[comId][groupIndex].users.findIndex(
            u => u === userId
          )

          this.groups = {
            ...this.groups,
            [comId]: [
              ...this.groups[comId].slice(0, groupIndex),
              {
                ...this.groups[comId][groupIndex],
                users: [
                  ...(value[key]
                    ? userIndex > -1
                      ? this.groups[comId][groupIndex].users
                      : [...this.groups[comId][groupIndex].users, userId]
                    : userIndex > -1
                      ? [
                          ...this.groups[comId][groupIndex].users.slice(
                            0,
                            userIndex
                          ),
                          ...this.groups[comId][groupIndex].users.slice(
                            userIndex + 1
                          )
                        ]
                      : this.groups[comId][groupIndex].users)
                ]
              },
              ...this.groups[comId].slice(groupIndex + 1)
            ]
          }

          {
            const _user = this.users[comId].find(u => u.id === userId)
            if (!_user) {
              const userUser = User.all.slice().find(u => u.id === userId)
              if (userUser) {
                this.users = {
                  ...this.users,
                  [comId]: [...this.users[comId], userUser]
                }
              }
            }
          }
        })

        return res.data.data
      })
      .catch(e => {
        console.warn(e)
        return Promise.reject()
      })
  }
}

export default new Community()



// WEBPACK FOOTER //
// ./src/stores/Community.js